export const SHOW_TAKEOVER_MODAL = "UI/TAKEOVER_MODAL/SHOW";
export const HIDE_TAKEOVER_MODAL = "UI/TAKEOVER_MODAL/HIDE";
